import { Component } from '@angular/core';
import { ExpandableContactFormComponent } from './expandable-contact-form.component';

@Component({
  selector: 'app-expandable-contact-form-mobile',
  templateUrl: './expandable-contact-form-mobile.component.html',
  styleUrls: ['./expandable-contact-form-mobile.component.scss']
})

export class ExpandableContactFormMobileComponent extends ExpandableContactFormComponent {
}



// WEBPACK FOOTER //
// ./src/app/shared/expandable-contact-form/expandable-contact-form-mobile.component.ts